import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
} from "@material-ui/core";
import { Field, useFormikContext } from "formik";
import { RadioGroup } from "formik-material-ui";
import React from "react";

export default function PaymentForm() {
  const formik = useFormikContext();

  function changePaymentOption(val) {
    formik.setFieldValue("paymentOption", val);
  }
  return (
    <FormControl
      component="fieldset"
      name="paymentOption"
      style={{ width: "100%" }}
      error={Boolean(formik.touched.paymentOption && formik.errors.paymentOption)}
    >
      <FormLabel component="legend">Please choose one:</FormLabel>
      <Field
        component={RadioGroup}
        name="paymentOption"
        style={{ marginTop: 12, marginBottom: 12 }}
        onChange={(e) => changePaymentOption(e.target.value)}
      >
        <Accordion expanded={formik.values.paymentOption === "mail"} style={{ width: "100%" }}>
          <AccordionSummary
            expandIcon={null}
            arial-label="Select and Expand"
            aria-controls="mail-payment"
            id="mail-payment"
            onClick={() => changePaymentOption("mail")}
          >
            <FormControlLabel value="mail" control={<Radio tabIndex={-1} />} label="I will mail a check for payment" />
          </AccordionSummary>
          <AccordionDetails style={{ display: "block" }}>
            <div>
              <p>You may mail your $25 check to the Office of Vital Records and Statistics:</p>
              <p>
                Vital Records - Utah Adoption Registry
                <br />
                P.O. Box 141012
                <br />
                Salt Lake City, UT 84114
              </p>
            </div>
          </AccordionDetails>
        </Accordion>
        <Accordion expanded={formik.values.paymentOption === "previous"} style={{ width: "100%" }}>
          <AccordionSummary
            expandIcon={null}
            arial-label="Select and Expand"
            aria-controls="previous-payment"
            id="previous-payment"
            onClick={() => changePaymentOption("previous")}
          >
            <FormControlLabel
              value="previous"
              control={<Radio tabIndex={-1} />}
              label="I paid when I registered previously"
            />
          </AccordionSummary>
          <AccordionDetails>
            <p>
              Letters were mailed and emailed to the addresses on record of those who previously registered. Previous
              registrants will be verified and no additional fee will be required.
            </p>
          </AccordionDetails>
        </Accordion>
        {formik.touched.paymentOption && formik.errors.paymentOption && (
          <FormHelperText>{formik.errors.paymentOption}</FormHelperText>
        )}
      </Field>
    </FormControl>
  );
}
